

import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import TileWMS from 'ol/source/TileWMS';
import LayerSwitcher from 'ol-layerswitcher';
import "ol-layerswitcher/src/ol-layerswitcher.css";
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {Circle as CircleStyle,Fill,   RegularShape, Stroke, Style, Text} from 'ol/style';
 
import { Timeline,DataSet } from "vis-timeline/standalone";
import Point from 'ol/geom/Point';
import Layer from 'ol/layer/Layer';
import {fromLonLat,transformExtent} from 'ol/proj.js';
import {getVectorContext} from 'ol/render.js';
 
import Feature from 'ol/Feature';


import LayerGroup from 'ol/layer/Group';
import Collection from 'ol/Collection';


import './style.css';


import './radar.js';

import './autopuri.js';
//import './model.js';
//getContext('2d', { willReadFrequently: true });


const c_image = new CircleStyle({
  radius: 5,
  fill: new Fill({
    color: 'rgba(255, 0, 0, 0.3)',
  }),
  stroke: new Stroke({color: 'red', width: 1}),
});
const style = new Style({
  image: c_image,
  fill: new Fill({
    color: 'rgba(255, 0, 255, 0.6)',
  }),
  stroke: new Stroke({
    color: '#319FD3',
    width: 1,
  }),
  text: new Text({
    font: '12px Calibri,sans-serif',
    margin:10,
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }),
    willReadFrequently: true, 
  }),
});

const style_postaje = new Style({
  image: new CircleStyle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(0, 255, 0, 0.3)',
    }),
    stroke: new Stroke({color: 'green', width: 1}),
  }),
  fill: new Fill({
    color: 'rgba(0, 255, 0, 0.6)',
  }),
  stroke: new Stroke({
    color: '#319FD3',
    width: 1,
  }),
  willReadFrequently: true,
 /* text: new Text({
    font: '12px Calibri,sans-serif',
    margin:10,
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }), 
  }),*/
});







const clc_Layer=  new TileLayer({
 //extent: [-13884991, 2870341, -7455066, 6338219],
 title: 'CLC 2018',
  source: new TileWMS({
    url: 'https://image.discomap.eea.europa.eu/arcgis/rest/services/Corine/CLC2018_WM/MapServer/export',
    params: {'LAYERS':'show',   'transparent':true, 'format':'png', 'f':'image' },
   
  }),
  visible:false,
})


clc_Layer.on('change:visible', function (e) {

 
  if(!e.oldValue){
    document.getElementById('CLC_LEGEND').style.display='block'

  }
  else{
    document.getElementById('CLC_LEGEND').style.display='none'

  }
})


const  coastline=new TileLayer(
//https://image.discomap.eea.europa.eu/arcgis/rest/services/EUHydro/EUHydro_Coastline/MapServer/export?bbox=1736814.5569279396%2C5302504.860276667%2C2038769.0603569464%2C5492589.2494054455&bboxSR=102100&imageSR=102100&size=1401%2C882&dpi=105.60000228881836&format=png32&transparent=true&layers=show%3A0&f=image
{
  title: 'Priobalne vode',
//extent: [1736814.5569279396, 5302504.860276667, 2038769.0603569464, 5492589.2494054455],
source: new TileWMS({
  url: 'https://image.discomap.eea.europa.eu/arcgis/rest/services/EUHydro/EUHydro_Coastline/MapServer/export',
  params: {'LAYERS':'show',   'transparent':true, 'format':'png', 'f':'image' },
}
),
visible:false,
})

const  sentinel=new TileLayer(
   {
    title: 'Sentinel2',
  //extent: [1736814.5569279396, 5302504.860276667, 2038769.0603569464, 5492589.2494054455],
  source: new TileWMS({
    url: 'http://caat.fesb.hr:8080/geoserver/sentinel_time/wms',
    params: {'LAYERS': 'sentinel_time:sentinel16','TIME':'2015-07-28T00:00:00.000Z'},
  }
  )  ,
  visible:false,
  })
 
 
const ispusti_layer = new VectorLayer({
  title:'Ispusti',
  source: new VectorSource({
    url: './data/discharge.json',
    format: new GeoJSON(),
  }),
  style: function (feature) {
    //style.getText().setText(feature.get('Unnamed: 0'));
    return style;
  },
});

const postaje_layer = new VectorLayer({
  title:'Mjerne Postaje',
  source: new VectorSource({
    url: './data/postaje.json',
    format: new GeoJSON(),
  }),
 /* style: function (feature) {
    style_postaje.getText().setText(feature.get('POSTAJA'));
    return style_postaje;
  },*/
  style: style_postaje,
});
const vodnaTjelaLayer = new VectorLayer({
  title:'Vodna Tijela',
  source: new VectorSource({
    url: './data/VodnaTijela.geojson',
    format: new GeoJSON(),
  }),
  style: function (feature) {
    //style.getText().setText(feature.get('Unnamed: 0'));
    return style;
  },
});


var parametriGroup=  new LayerGroup({
  title: 'Kampanje mjerenja',
  layers: [ ],
  visibility:false,
  visible:false,
})

parametriGroup.on('change:visible', function (e) {
  console.log('aaaaaaaaa')
  console.log(e)

 
  if(!e.oldValue){
    document.getElementById('timeline_control').style.display='block'

  }
  else{
    document.getElementById('timeline_control').style.display='none'

  }
})


const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    }),
    clc_Layer,
    coastline,
    ispusti_layer,
    postaje_layer,
    sentinel,
    vodnaTjelaLayer,
    parametriGroup,
    
  

   autopuri_layer,
   tockice,
   strelice,

  ],
  view: new View({
  /*  center: [16.47, 43.53],
    projection: 'EPSG:4326',
*/
projection: 'EPSG:3857',
center: [1830000, 5380000],
    zoom: 11
  })
});
var layerSwitcher= new LayerSwitcher({ reverse: true ,startActive: true,groupSelectStyle: 'group'})
 

// Add a `change:visible` listener to all layers currently within the map
/*layerSwitcher.forEachRecursive(map, function(l, idx, a) {
  l.on("change:visible", function(e) {
      var lyr = e.target;
      console.log(lyr.get('title'), lyr.getVisible());
  });
});*/
map.addControl(layerSwitcher);
//var sidebar = new  Sidebar({ element: 'sidebar', position: 'right' });
//map.addControl(sidebar);

layerSwitcher.showPanel();

const  overLay=new TileLayer({
  // title: 'Obalna linija',
  source: new TileWMS({
     url: 'http://caat.fesb.hr:8080/geoserver/sentinel_time/wms',
     projection: 'EPSG:404000',
     params: {'FORMAT': 'image/png', 
          'tiled': true,
       "LAYERS": 'sentinel_time:Obala_maska',
    },
   }
   ) ,
 visible:true,
 displayInLayerSwitcher:false,
 })
autopuri_layer.on('change:visible', function (e) {

  if(!e.oldValue){
    document.getElementById('autopuri_tiff_control').style.display='block'
    map.addLayer(overLay)

  }
  else{
    document.getElementById('autopuri_tiff_control').style.display='none'
    map.removeLayer(     overLay)

  }

})



/***hover */
const highlightStyle = new Style({
  fill: new Fill({
    color: 'rgba(255,255,255,0.7)',
  }),
  stroke: new Stroke({
    color: '#3399CC',
    width: 3,
  }),
  text: new Text({
    font: '12px Calibri,sans-serif',
  
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }),
  }),
});
let selected = null;
const status = document.getElementById('status');
/*map.on('change', function (e) {
  console.log(e)
  if(strelice.visibility){
    document.getElementById('timeline').style.display='block'

  }
  else{
    document.getElementById('timeline').style.display='none'

  }
})*/

map.on('pointermove', function (e) {
  
  if (selected !== null) {
    selected.setStyle(undefined);
    
    selected = null;
  }
  map.forEachFeatureAtPixel(e.pixel, function (f) {
    selected = f;
    //console.log('eeee'+f )
    // f.setStyle(highlightStyle.getText().setText(f.get('Unnamed: 0')));
     f.setStyle(  function (f) {
       if (f.get('Unnamed: 0'))      highlightStyle.getText().setText('ISPUST:' +f.get('Unnamed: 0'));
       if (f.get('POSTAJA'))      highlightStyle.getText().setText('POSTAJA: ' +f.get('POSTAJA'));
       if (f.get('label'))      highlightStyle.getText().setText('value: ' +f.get('label'));

      return highlightStyle;
    }
    ); 
  

    return true;
  });
/*
  if (selected) {

    if (selected.get('Unnamed: 1')){
      status.innerHTML = '&nbsp;Hovering: ' + selected.get('Unnamed: 1');}
    else if (selected.get('POSTAJA'))
   { status.innerHTML = '&nbsp;Hovering: ' + selected.get('POSTAJA');}
  }else {
    status.innerHTML = '&nbsp;';
  }*/
});



 


 

let xhr = new XMLHttpRequest();
xhr.onload = function () {
  let xres = xhr.responseText
 // console.log(xres)
  var mjerenja_data=JSON.parse(xres)
  var kampanje=[]
 
  mjerenja_data.forEach(function(item ){
    if (!(kampanje.includes(item.kampanja))){
      kampanje.push(item.kampanja)
    }
  })
  //console.log(kampanje)
 
 //kreiraj timeline
 
 var container = document.getElementById("timeline");
 //var dates = ['2023-01-01T00:00:00.000Z','2022-01-01T00:00:00.000Z','2021-01-01T00:00:00.000Z' ,]
var timeline_data=[]
 var j=0
 kampanje.forEach(function(item){
  timeline_data.push({id:j,content:item,start:item+"T09:00:00"})
j++
 })
 var items = new DataSet(timeline_data);
 
 // Configuration for the Timeline
 var options = {
   editable: false,
   showTooltips:true,
 
   template: function (item, element, data) {
       var html = ' <b>kampanja</b>: ' +item.content; // generate HTML markup for this item
       return html;
     },
   // always snap to full hours, independent of the scale
   snap: function (date, scale, step) {
     var hour = 60 * 60 * 1000;
     return Math.round(date / hour) * hour;
   },
   start:'2022-01-01',

 };
 
 // Create a Timeline
 //https://visjs.github.io/vis-timeline/docs/timeline/#getEventProperties
 var timeline = new Timeline(container, items, options);

 timeline.on('click', function (properties) {
   var datum_kampanje=kampanje[properties.item]

var w_params= ["Chl","Turbidity","Secchi depth","SAL","Temp","CDOM"]



 let colLay=parametriGroup.getLayers()
 while(parametriGroup.getLayers().getLength()>0){
 
  parametriGroup.getLayers().clear()
}
parametriGroup.set('name', 'kampanja: '+datum_kampanje)
/*parametriGroup = new LayerGroup({
  name: 'kampanja: '+datum_kampanje
});*/
w_params.forEach(function(param){

    //console.log("filter" +param)
    var params_data=mjerenja_data.filter(function(item){
      return item.kampanja == datum_kampanje && item.parametar == param;         
       })
    //console.log("create feature")
    if (params_data.length>0){
    var poinsMjerenja=new Array( )
    params_data.forEach(function(item){
    var p=new Point([item.longitude, item.latitude])
    var ff=new Feature({geometry: p, label: item.value})
  
    ff.getGeometry().transform('EPSG:4326', 'EPSG:3857')
   // console.log(ff)

    poinsMjerenja.push(ff)


   })

    //console.log("create source")
    let source = null//cam_new_layer.getSource();
    source = new VectorSource();//({style: style_postaje,    });
    source.addFeatures(poinsMjerenja)

   // console.log("create layer")
    let new_param_layer = new VectorLayer({    type: 'base',
    combine: true,});

   //new_param_layer.set('title', "Kampanja " + datum_kampanje + " " + param)
    new_param_layer.set('title',  param)
  
    new_param_layer.setSource(source)//().addFeatures([dotLineFeature]) 
    new_param_layer.setStyle(function (feature) {
    //  console.log(feature.get('label'))
      
      let style1 = new Style({
        image: new CircleStyle({
          radius: 5*feature.get('label'),
          fill: new Fill({
            color: 'rgba(255, 0, 0, 0.3)',
          }),
          stroke: new Stroke({color: 'red', width: 1}),
        }),
  fill: new Fill({
    color: 'rgba(0, 0, 0, 0.6)',
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 1,
  }),
  text: new Text({
    font: '12px Calibri,sans-serif',
    margin:10,
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }), 
  }),
      });
      return style1
    })
  //  console.log("add layer to group")
  

       /******************************/
   map.getLayers().forEach(function (layer) {
    //console.log(layer)
    if (layer.getLayers) {
      layer.set('title', "Kampanja " + datum_kampanje )
      // get inner layers from group layer as Collection
      if (layer.getLayers() instanceof Collection) {
        let innerLayers = layer.getLayers()
        let exists = 0
        innerLayers.forEach(function (inLayer) {
          if (inLayer.get('title') == param) {
            inLayer.setSource(source)
            //inLayer.Style=style_kamere
            exists = 1
          }
        })
        if (exists == 0)
             innerLayers.push(new_param_layer);

        }


    }
  });

    /*************************************** */
  }

   })
   //add group 
   //map.addLayer(parametriGroup);
   //layerSwitcher.hidePanel();

   layerSwitcher.showPanel();




   
/*
    var chl_data=mjerenja_data.filter(function(item){
     return item.kampanja == datum_kampanje && item.parametar == 'Chl';         
      })
   console.log(chl_data);  

//parametri Chl
   let source = null//cam_new_layer.getSource();
   let cam_new_layer = new VectorLayer({});
 
  //console.log(feature)
   cam_new_layer.set('title', "Kampanja " + datum_kampanje + " " + 'Chl')
   var poinsMjerenja=new Array( )
   chl_data.forEach(function(item){
    var p=new Point([item.longitude, item.latitude])
    var ff=new Feature({geometry: p, label: item.value})
  
    ff.getGeometry().transform('EPSG:4326', 'EPSG:3857')
   // console.log(ff)

    poinsMjerenja.push(ff)


   })
//console.log(poinsMjerenja)
 source = new VectorSource({style: style_postaje,    });
   source.addFeatures(poinsMjerenja)
  // console.log(source.getProjection())
   //console.log(clc_Layer.getSource().getProjection())

  // odabrana_mjerenja.setSource(source)
   cam_new_layer.setSource(source)//().addFeatures([dotLineFeature]) 
    map.addLayer(cam_new_layer)
   console.log(ispusti_layer.getSource())*/
// var dotLineFeature = new Feature({ geometry: geomline, })

 });
   

}
xhr.open("GET", 'data/data_mjerenja.json '  , true);
xhr.send();
//retrieve_appropriate_radar_data()

